import React from 'react';
import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';

const AuthLayout = () => {
    return (
        <div className="min-h-screen w-full flex items-center justify-center relative overflow-hidden bg-[var(--bg-dark)]">
            {/* Ambient Background Effects */}
            <div className="absolute top-[-20%] right-[-10%] w-[600px] h-[600px] bg-[var(--primary-color)] opacity-20 blur-[120px] rounded-full animate-pulse"></div>
            <div className="absolute bottom-[-20%] left-[-10%] w-[500px] h-[500px] bg-[var(--secondary-color)] opacity-20 blur-[100px] rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>

            {/* Grid Overlay */}
            <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20"></div>

            {/* Content Container */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="relative z-10 w-full max-w-md p-1 mx-4"
            >
                <Outlet />
            </motion.div>

            {/* Footer */}
            <div className="absolute bottom-4 text-center w-full z-10 opacity-50 text-[10px] uppercase tracking-[0.2em] text-[var(--text-secondary)]">
                Helix · v0.3.0 · Eternium LLC
            </div>
        </div>
    );
};

export default AuthLayout;
